import React from "react";
import "./style.scss";

const Header: React.FC = () => {

	return (
		<div
			className={`header expanded`}
		>
		</div>
	);
};

export default Header;
